import { BUUnitData, OrgTreeData } from '~/data/orgunits';
import { getNumberOrUndefined } from '~/utils/helper';

type OrganizationTreeOption = {
  id: string;
  text: string;
  items?: OrganizationTreeOption[];
  selected: boolean;
  expanded: boolean;
};

export const convertListToTreeOptions = (
  organizationTree: OrgTreeData[],
  expanded: number[],
  selected?: number,
  unitOptions?: number[],
): {
  optionTree: OrganizationTreeOption[];
  pathToSelected: number[];
  selectedUnit?: BUUnitData;
} => {
  const hasUnitOptionsDefined = typeof unitOptions !== 'undefined';

  const primaryTreeUnits = organizationTree.find(
    (tree) => tree.fTreeId === 1,
  )?.units;

  const accessibleUnits = hasUnitOptionsDefined
    ? primaryTreeUnits?.filter((unit) => {
        const unitId = getNumberOrUndefined(unit.fTreeUnitId);

        return unitId ? unitOptions?.includes(unitId) : false;
      })
    : primaryTreeUnits;
  const rootUnits = accessibleUnits?.filter((unit) => {
    if (unit.fTreeParentUnitId === '#') {
      return true;
    }

    return (
      hasUnitOptionsDefined &&
      !accessibleUnits.some((u) => u.fTreeUnitId === unit.fTreeParentUnitId)
    );
  });

  const selectedUnit = !!selected
    ? primaryTreeUnits?.find((unit) => unit.fTreeUnitId === `${selected}`)
    : undefined;

  let selectedUnitBranch: number[] = [];

  const convertTreeUnitsToOptions = (units?: BUUnitData[]) => {
    return units?.map((unit): OrganizationTreeOption => {
      const { fTreeUnitId, fTreeUnitName, fTreeParentUnitId } = unit;
      const unitId = parseInt(fTreeUnitId);
      const parentId = getNumberOrUndefined(fTreeParentUnitId);

      const subUnits = primaryTreeUnits?.filter((u) => {
        return u.fTreeParentUnitId === fTreeUnitId;
      });
      const items = convertTreeUnitsToOptions(subUnits);

      const isSelectedUnit = selected === unitId;
      const hasSelectedSubUnit = selectedUnitBranch.includes(unitId);
      if (!!parentId && (isSelectedUnit || hasSelectedSubUnit)) {
        selectedUnitBranch.push(parentId);
      }

      return {
        id: fTreeUnitId,
        text: fTreeUnitName,
        items,
        expanded: expanded.includes(unitId) || hasSelectedSubUnit,
        selected: isSelectedUnit,
      };
    });
  };

  return {
    optionTree: convertTreeUnitsToOptions(rootUnits) ?? [],
    pathToSelected: selectedUnitBranch,
    selectedUnit,
  };
};
